module.exports = __webpack_public_path__ + "img/mov.b08a6702.png";